import { BannerTop } from './components/BannerTop/BannerTop'
import { Banner } from './components/Banner/Banner'
import { BannerTwo } from './components/BannerTwo/BannerTwo'
import { SaleBanner } from './components/SaleBanner/SaleBanner'
import { CategoriesTwo } from './components/CategoriesTwo/CategoriesTwo'
import { CategoriesTwoMobile } from './components/CategoriesTwoMobile/CategoriesTwoMobile'
import { CategoriesThree } from './components/CategoriesThree/CategoriesThree'
import { CategoriesThree2 } from './components/CategoriesThree-2/CategoriesThree-2'
import { BackToSchool } from './components/BackToSchool/BackToSchool'
import { Vulcano } from './components/Vulcano/Vulcano'
import { BannerEvo } from './components/BannerEvo/BannerEvo'
import { DiaDeLaMadre } from './components/DiaDeLaMadre/DiaDeLaMadre'

export const HomeLippi = () => {
  return (
    <main>
      <BannerEvo />
      <CategoriesThree />
      <CategoriesTwo />
      <CategoriesTwoMobile />
      <DiaDeLaMadre />
      <BackToSchool />
      <Banner />
      {/* <BannerTop /> */}
      {/* <Vulcano /> */}
      {/* <BannerTwo />
      <SaleBanner /> */}
      <CategoriesThree2 />
    </main>
  )
}
